import actionTypes from 'redux/actionTypes';

export function getFirstTimeUsrStatus(data) {
	return {
		type: actionTypes.GET_FIRSTTIME_USR_STATUS,
		payload: data
	};
}

export function setFirstTimeUsrStatus(data) {
	return {
		type: actionTypes.SET_FIRSTTIME_USR_STATUS,
		payload: data
	};
}

export function errFirstTimeUsrStatus(err) {
	return {
		type: actionTypes.ERR_FIRSTTIME_USR_STATUS,
		payload: err
	};
}

export function resetFirstTimeUsrStatus() {
	return {
		type: actionTypes.RESET_FIRSTTIME_USR_STATUS
	};
}

export function setStartTour(payload) {
	return {
		type: actionTypes.SET_PREVIEW_TOUR,
		payload
	};
}

export function setCustomDatasetTour(payload) {
	return {
		type: actionTypes.SET_CUSTOM_DATASET_TOUR,
		payload
	};
}
